// extracted by mini-css-extract-plugin
export var body = "_l8-8";
export var button = "_l8-0";
export var closeButton = "_l8-5";
export var content = "_l8-3";
export var empty = "_l8-f";
export var grid = "_l8-c";
export var header = "_l8-4";
export var icon = "_l8-1";
export var option = "_l8-d";
export var optionSelected = "_l8-e";
export var overlay = "_l8-2";
export var searchIcon = "_l8-a";
export var searchInput = "_l8-b";
export var searchWrapper = "_l8-9";
export var title = "_l8-6";
export var visuallyHidden = "_l8-7";